module.exports = __webpack_public_path__ + "img/gard_horizontal_3.2e3299e3.png";